import { Component, type PropsWithChildren, type ReactNode } from "react";
import { type ReceiptServerTypeUnion } from "../../../Data/_Bases/BaseReceiptRepository";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props extends PropsWithChildren {
    type: ReceiptServerTypeUnion;
}

interface State {
    hasError: boolean;
}

export class ReceiptErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    protected static getDerivedStateFromError(): State {
        return {
            hasError: true,
        };
    }

    public componentDidCatch(err: Error, errorInfo: { componentStack: string; }): void {
        console.error("Error caught by Print", err, errorInfo);
    }

    public render(): ReactNode {
        if(this.state.hasError) {
            if(this.props.type === "TEXT_ONLY") {
                return "ERROR RENDERING RECEIPT";
            }

            return (
                <div className="text-center">
                    <div className="text-6xl text-red-500 mb-2">
                        <FontAwesomeLight icon="exclamation-triangle" />
                    </div>
                    <span className="text-lg font-bold">Error</span>
                    <div>Failed to render receipt</div>
                </div>
            );
        }

        return this.props.children;
    }
}
